"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToSSE = subscribeToSSE;
const redux_saga_1 = require("redux-saga");
function subscribeToSSE(eventSrc) {
    return (0, redux_saga_1.eventChannel)((emitter) => {
        eventSrc.addEventListener('open', (event) => {
            emitter(event);
        });
        eventSrc.addEventListener('error', (err) => {
            console.error(err);
            emitter(err);
        });
        eventSrc.addEventListener('message', (event) => {
            emitter(event);
        });
        return () => {
            eventSrc.close();
            emitter(redux_saga_1.END);
        };
    });
}
//# sourceMappingURL=index.js.map